import React from 'react'


export const LineFooter: React.FC<{
  canCollapse: boolean
  expanded: boolean
  onToggleExpanded: () => void
}> = ({ canCollapse, expanded, onToggleExpanded }) => (
  <div className="mt-3 flex items-center justify-between">
    {canCollapse && (
      <button
        type="button"
        onClick={onToggleExpanded}
        className="text-sm font-medium text-brand-700 hover:text-brand-800 focus:outline-none focus:underline cursor-pointer"
        aria-expanded={expanded}
      >
        {expanded ? 'Show less' : 'Show more'}
      </button>
    )}
    <div className="text-xs text-foreground/60">
      <span>&nbsp;</span>
    </div>
  </div>
)
